<!-- 商户管理 -->
<template>
  <div class="content">
    <div class="bodycontent">
      <div class="option">
        <el-button
          type="primary"
          style="margin-right:30px"
          @click="addmerchant()"
          >添加商户</el-button
        >
        <el-radio-group v-model="menus" @change="changeRadio">
          <el-radio-button label="商户列表"></el-radio-button>
          <el-radio-button label="商户申请"></el-radio-button>
          <el-radio-button label="账号管理"></el-radio-button>
        </el-radio-group>
      </div>
      <!-- 商户列表 -->
      <ShopsTable v-if="menus == '商户列表'" :tableData="shopList"></ShopsTable>
      <!-- 商户申请 -->
      <ShopsApply
        :tableData="applyList"
        v-if="menus == '商户申请'"
        @apply="apply"
        @refuse="refuse"
      ></ShopsApply>
      <!-- 账号管理 -->
      <AccountManage
        :tableData="accountManage"
        v-if="menus == '账号管理'"
      ></AccountManage>
      <!-- 门店列表 -->
      
      <!-- 分页按钮 -->
      <div class="Otherpage">
        <div class="changePage">
          <div @click="upPage" class="btnColor">
            <span>上一页</span>
          </div>
          <div>
            <span>{{ page }}</span>
          </div>
          <div @click="downPage" class="btnColor">
            <span>下一页</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { myShopList } from "./testData";
import ShopsTable from "./tables/shopsTable";
import ShopsApply from "./tables/shopsApply";
import AccountManage from "./tables/accountManage";
import StoreList from "./tables/storeList";
import { MerchantList, EditMerchant } from "@/api/merchant";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  components: {
    ShopsTable,
    ShopsApply,
    AccountManage,
    StoreList
  },
  data() {
    return {
      menus: "商户列表",
      shopList: [], //商户列表
      applyList: [], //商户申请列表
      accountManage: [], //账号管理列表
      storeList: [], //门店列表
      params: {},
      page: 1
    };
  },
  mounted() {
    // this.testfn();
    this.$store.commit("SET_STATE", "2");
    this.params = {
      token: this.token,
      app_id: this.app_id
    };
    this.getShopList();
  },
  methods: {
    testfn() {
      this.shopList = myShopList;
      console.log(this.shopList);
    },
    // 根据tab页获取数据
    getData(){
      if (this.menus == "商户列表") {
        this.getShopList();
      } else if (this.menus == "商户申请") {
        this.getApplyList();
      }
    },
    // 获取商户列表
    getShopList() {
      var data = Object.assign({}, this.params);
      data.page = this.page;
      data.apply_status = 2;
      MerchantList(data).then(res => {
        if (res.code == "1") {
          this.shopList = res.data;
          this.tableData = this.shopList;
        }
      });
    },
    //获取商户申请列表
    getApplyList() {
      var data = Object.assign({}, this.params);
      data.page = this.page;
      data.apply_status = 0;
      MerchantList(data).then(res => {
        if (res.code == "1") {
          this.applyList = res.data;
          this.tableData = this.shopList
        }
      });
    },
    //通过商户申请
    apply(i){
      console.log(this.applyList[i])
      var data = Object.assign({},this.applyList[i])
      data.apply_status = 2;
      data.token = this.token;
      EditMerchant(data).then(res => {
        if (res.code == "1") {
          this.$message({
            type:"success",
            message: "已通过"
          });
          this.getApplyList();
        }else{
          this.$message({
            type:"warning",
            message: res.msg
          });
        }
      });
    },
    //拒绝商户申请
    refuse(i){
      console.log(this.applyList[i])
      var data = Object.assign({},this.applyList[i])
      data.apply_status = 3;
      data.token = this.token;
      EditMerchant(data).then(res => {
        if (res.code == "200") {
          this.getApplyList()
        }
      });
    },
    //切换tab页
    changeRadio(val) {
      this.page = 1;
      if (val == "商户列表") {
        this.getShopList();
      } else if (val == "商户申请") {
        this.getApplyList();
      }
    },
    addmerchant() {
      this.$router.push({
        path: "addMerchant"
      });
    },
    upPage() {
      // 上一页
      this.page--;
      if (this.page == 0) {
        this.page = 1;
        this.getData();
      } else {
        this.getData();
      }
    },
    downPage() {
      // 下一页
      if (this.tableData.length == 10) {
        this.page++;
        console.log(this.page);
        this.getData();
        console.log(this.tableData.length);
        if (this.tableData.length == 0) {
          this.$message("没有更多了");
          this.page--;
          this.getData();
        }
      }else{
        this.$message("没有更多了");
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$store.commit("SET_STATE", "1");
    next();
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 10px 55px 30px 0;
  height: calc(100vh - 102px);
  .bodycontent {
    position: relative;
    padding: 0px 27px 0;
    font-size: 14px;
    height: 96%;
    border: 1px solid #f1f1f1;
    box-shadow: 0 0 3px #f1f1f1;
    .option {
      height: 79px;
      line-height: 79px;
    }
    // table
    .el-table {
      box-shadow: 0 0 3px #f1f1f1;
      height: 85%;
      padding-left: 20px;
      .cell {
        text-align: center !important;
      }
    }
    // table里面的子行
    .table_scope_line {
      height: 22px;
      line-height: 22px;
      font-size: 12px;
      text-align: center;
    }
    .table_button_line {
      height: 40px;
      line-height: 40px;
      font-size: 12px;
      text-align: center;
    }
    //分页
    .Otherpage {
      height: 34px;
      width: 200px;
      position: absolute;
      bottom: 0;
      .changePage {
        height: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        div {
          height: 100%;
          width: 30%;
          text-align: center;
          line-height: 34px;
        }
        .btnColor {
          background: #b0b5bb30;
        }
      }
    }
  }
}
</style>
